import { componentFactory } from 'vue-tsx-support';

import { injectStylesMixin } from '../../mixins/inject-styles';

import styles from './jtn-ui-loader-line.styles.scss?module';

export default componentFactory.mixin(injectStylesMixin(styles)).create({
  name: 'JtnUiLoaderLine',
  props: {
    full: {
      type: Boolean,
      default: false
    }
  },
  render() {
    const attributes = {
      attrs: this.$attrs,
      on: this.$listeners
    };

    return (
      <div class={[styles.loaderLine, this.full ? styles.full : '']} {...attributes} />
    );
  }
});
